var map = {
	"./logo-1-1-2.png": 99792,
	"./logo-1-1.png": 3086,
	"./logo-1-2.png": 28825,
	"./logo-1-3.png": 19113,
	"./logo-2-2.png": 44357,
	"./logo-2-3.png": 35309,
	"./logo-3-1-1.png": 77205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55412;